<app-environment-banner />
<router-outlet></router-outlet>